import React, { useState } from "react";
import Modal from "../modal/Modal";
import CertificationUploadForm from "../forms/CertificationUploadForm";

const CertificationUpload = ({
  register,
  handleSubmit,
  errors,
  setValue,
  readOnly = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onSubmit = (data) => {
    setIsModalOpen(false);
  };

  return (
    <div>
      {/* Certification Dropdown */}
      <div>
        <label className="font-bold">Certifications</label>
        <div
          className="border p-3 mt-2 rounded-md cursor-pointer w-2/4 flex justify-between items-center"
          onClick={() => setIsModalOpen(true)}
        >
          <span className="text-gray-500">Select Certification</span>
          <span>▼</span>
        </div>
        {/* Show validation error for Certifications */}
        {errors.CertificationName && (
          <p className="text-red-500 text-sm mt-1">
            {errors.CertificationName.message}
          </p>
        )}
        {errors.provider && (
          <p className="text-red-500 text-sm mt-1">{errors.provider.message}</p>
        )}
        {errors.description && (
          <p className="text-red-500 text-sm mt-1">
            {errors.description.message}
          </p>
        )}
        {errors.issueDate && (
          <p className="text-red-500 text-sm mt-1">
            {errors.issueDate.message}
          </p>
        )}
        {errors.expirationDate && (
          <p className="text-red-500 text-sm mt-1">
            {errors.expirationDate.message}
          </p>
        )}
      </div>

      {/* Modal */}
      <Modal
        label={"Profile Info"}
        width="w-[700px]"
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        {/* Form */}
        <CertificationUploadForm
          register={register}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          errors={errors}
          onClose={() => setIsModalOpen(false)}
          setValue={setValue}
          readOnly={readOnly}
        />
      </Modal>
    </div>
  );
};

export default CertificationUpload;
